import { Tooltip } from '@mui/material';

import {
  SERVICE_CATEGORY_META,
  getServiceCategoryLabel,
  isKnownServiceCategory,
} from '@/constants/serviceCategories';

import AppStatusChip from '../buttons/AppStatusChip';

/**
 * ServiceCategoryChip — pillola della categoria di servizio (icona + testo).
 *
 * `service_category` dice *perché* la persona viaggia (centro diurno, scuola,
 * terapie…) ed è il terzo classificatore, distinto da `service_mode` (come) e
 * `trip_type` (cosa). Gemello di <ServiceModeChip>, stessa struttura.
 *
 * Una categoria **sconosciuta** non viene nascosta né ricondotta ad "Altro":
 * `normalizeServiceCategory` di proposito lascia passare le sigle che il
 * registro non conosce, ed è da quelle che si capisce quali categorie mancano.
 * Qui si mostrano come sono, in grigio e con un tooltip che lo dice.
 */
export default function ServiceCategoryChip({ category, fullCell = false, ...rest }) {
  if (!category) return null;

  const known = isKnownServiceCategory(category);
  const meta = SERVICE_CATEGORY_META[category];

  const chip = (
    <AppStatusChip
      variant={known ? meta.variant : 'neutral'}
      icon={known ? meta.icon : 'circle-question'}
      label={getServiceCategoryLabel(category)}
      fullCell={fullCell}
      {...rest}
    />
  );

  if (known) return chip;

  return (
    <Tooltip title={`Categoria non riconosciuta: "${category}". Va aggiunta al registro.`}>
      <span>{chip}</span>
    </Tooltip>
  );
}
